import React from 'react';
import {Redirect} from 'react-router-dom';

//
const IndexRoutes = [
    {
        path: '/help',
        // exact: true,
        component: () => <Redirect to="/help/main"/>,
    }
]

//
export {IndexRoutes};
